module.exports = __webpack_public_path__ + "img/riohacha.1c461463.png";